import React, { Component } from 'react';
import $ from 'jquery';
import Script from 'react-load-script';
import { BrowserRouter as Router, Switch, Route, Link, browserHistory } from 'react-router-dom';
import Helmet from 'react-helmet';

class Service extends Component {

	render() {
    return (
        <div>
        <Helmet
                title="Services| RAT Films | Creative Films and Solutions"
                meta={[
                  { name: 'description', content: "We offer comprehensive film-making services to corporate and other entities. Short Films, Feature films, Corporate videos and more." },
                  

                  ]}
              />
        <section className="page-section services ">
          <div className="container ">
            <h3 className="heading main">SERVICES</h3>
            <div className="srv-hlts" >
              <div className="srv-itm">
                  <div className="stylish">
                    <span className=" stylish-text">
                      <span className="style1"><span>TELEVISION</span><br />COMMERCIALS</span>
                    </span>
                  </div>
                  <img src={require('../img/shadow.png')} alt=""/>
                  <h3 className="ft-green desc">From Start to Finish with the perfect expertise.</h3>
              </div>
              <div className="srv-itm">
                  <div className="stylish">
                    <span className="stylish-text">
                      <span className="style1"><span>DIGITAL</span><br />CONTENT</span>
                    </span>
                  </div>
                  <img src={require('../img/shadow.png')} alt=""/>
                  <h3 className="ft-green desc">Virals / Online videos / Shorts / Corporates / AV's.</h3>
              </div>
              <div className="srv-itm">
                  <div className="stylish">
                    <span className=" stylish-text">
                      <span className="txt-rt"><span className="style1 ">STILL</span><br /><span className="style2">PHOTOGRAPHY</span></span>
                      <span className="style4">&</span>
                      <span className="style2">PRINT</span>
                    </span>
                  </div>
                  <img src={require('../img/shadow.png')} alt=""/>
                <h3 className="ft-green desc"></h3>
              </div>
              <div className="srv-itm">
                  <div className="stylish">
                    <span className=" stylish-txt">
                      <span><span className="style3"><span>SHORT</span></span><br /><span className="style1">FILMS</span></span>
                    </span>
                  </div>
                  <img src={require('../img/shadow.png')} alt=""/>
                <h3 className="ft-green desc"></h3>
              </div>
              <div className="srv-itm">
                  <div className="stylish">
                    <span className=" stylish-txt">
                      <span><span className="style2"><span>CELEBRITY</span><br />MANAGEMENT</span></span>
                    </span>
                  </div>
                  <img src={require('../img/shadow.png')} alt=""/>
                <h3 className="ft-green desc"></h3>
              </div>
              <div className="srv-itm">
                  <div className="stylish">
                    <span className=" stylish-text">
                      <span className="txt-rt"><span className="style3 "><span>CREATIVE</span></span><br /><span className="style1">SOLUTIONS</span></span>
                      <span className="style4">&</span>
                      <span className="style2">DESIGN</span>
                    </span>
                  </div>
                  <img src={require('../img/shadow.png')} alt=""/>
                <h3 className="ft-green desc"></h3>
              </div>  
    
            </div>
          </div>
        </section>
		
        </div>

		
    );
  }
}

export default Service;


// WEBPACK FOOTER //
// ./src/components/services.js